export default "__VITE_ASSET__C1SE$nM___"